import React from "react";

export default function Header() {
    return (
        <div className="header">
            <a href="https://fontmeme.com/fonts/tesla-font/"><img src="https://fontmeme.com/permalink/220626/f471a73f178ead28c7454adef41e78cb.png" alt="tesla-font" border="0"/></a>
            <h1 className="title--dashboard">Dashboard</h1>
        </div>
    )
}